import Share from "./share";

export { Share };
